import { MtxButton } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import ModaleDefaut from '@/components/ModaleDefaut/ModaleDefaut';
import { useAuth } from '@/hooks/useAuth';

import styles from './styles.module.css';

type DemoBlockedModalProps = {
  onClose: () => void;
};

const DemoBlockedModal: React.FC<DemoBlockedModalProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleQuitDemo = () => {
    onClose();
    logout();
    navigate('/', { replace: true });
  };

  return (
    <ModaleDefaut
      title={t('modals.demoBlockedModal.title')}
      content={
        <div className={styles.text}>
          <p>{t('modals.demoBlockedModal.message1')}</p>
          <p>{t('modals.demoBlockedModal.message2')}</p>
          <div className={styles.actions}>
            <MtxButton variant="tertiary" size="large" onClick={onClose}>
              {t('modals.demoBlockedModal.stayButton')}
            </MtxButton>
            <MtxButton variant="primary" size="large" onClick={handleQuitDemo}>
              {t('modals.demoBlockedModal.quitButton')}
            </MtxButton>
          </div>
        </div>
      }
      onClickClose={onClose}
      size="large"
      mobileStyle="stick-to-bottom"
    />
  );
};

export default DemoBlockedModal;
